import { Component, Input, ViewEncapsulation, inject } from '@angular/core';

import { LocationMapService } from './location-map.service';
import * as atlas from 'azure-maps-control';

@Component({
  selector: 'app-location-map',
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LocationMapComponent {
  private mapsService = inject(LocationMapService);

  @Input()
  public set addressString(value: string) {
    if (value) {
      this.setCoordinates(value);
    }
  }

  public map: atlas.Map;
  public currentLocationCoordinates?: [number, number] = [0, 0];

  private async setCoordinates(addressString: string) {
    this.currentLocationCoordinates =
      await this.mapsService.getCoordinatesFromAddress(addressString);

    this.map = new atlas.Map('azure-map', {
      ...this.mapsService.DefaultOptions,
      center: this.currentLocationCoordinates,
      style: 'satellite',
    });

    this.map.events.add('ready', async () => {
      const dataSource = new atlas.source.DataSource();
      this.map.sources.add(dataSource);

      const point = new atlas.Shape(
        new atlas.data.Point(
          new atlas.data.Position(
            this.currentLocationCoordinates![0],
            this.currentLocationCoordinates![1]
          )
        )
      );

      dataSource.add([point]);
      this.map.layers.add(new atlas.layer.SymbolLayer(dataSource));
    });
  }
}
